<template>
  <page-section>
    <integration-promotions-table
      :integration-id="model.id"
      :integration-type="model.type"
      :sync-enabled="model.params.sync_enabled"
      :sync-advanced="model.params.sync_advanced"
      :sync-disabled="syncDisabled"
    />
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import IntegrationPromotionsTable from '@/modules/integrations/components/IntegrationPromotionsTable'

export default {
  name: 'DynamicPromotions',
  components: { IntegrationPromotionsTable, PageSection },
  props: {
    model: {
      required: true
    }
  },
  computed: {
    syncDisabled() {
      let syncDisabled = false
      if (this.model.params.hasOwnProperty('sync_enabled')) {
        syncDisabled = !this.model.params.sync_enabled
      }
      return syncDisabled
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/dynamicpromotions/DynamicPromotions.vue